import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';
import {get as getStore} from 'svelte/store';
import { format } from 'svelte-i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/es';



// store Promise to avoid multiple simultaneous API calls
let tagsPromise;
let tags = [];

export function search(resource, config = {filter: null}) {
    tagsPromise = API.search(resource, config)
        .catch(() => {
            return [];
        })
        .then(pTags => {
            tags = pTags;
            return tags;
        })
    ;
    return tagsPromise;
}

export async function find(resource, id, config = {}) {
    let tag;
    return API.find('v2/' + resource, id, config)
        .catch(() => {
            return [];
        })
        .then(pTag => {
            tag = pTag;
            return tag;
        })
    ;
}

export async function save(data, files = [], config = {}) {
    return API.upsert('v2/tag', data, files, config)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                // api validation errors
                let toastConfig = {
                    data: data.name,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                if(config && config.massive_addition) toastConfig.error = errors;
                notificate('save_error', "toast", toastConfig);

                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: getStore(format)("notifications.element")})
            //returns saved element to update dataTables
            return apiData;
        })
    ;
}

export async function saveAssociation(data, files = [], config = {}) {
    return API.upsert(`v2/tag/association`, data, files, config)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            //returns saved element to update dataTables
            return apiData;
        })
    ;
}

export async function deleteAssociation(data, files = [], config = {}) {
    return API.deleteTags(`v2/tag/association/`, data, files, config)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                let toastConfig = {
                    data: data.name,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                if(config && config.massive_addition) toastConfig.error = errors;
                notificate('save_error', "toast", toastConfig);

                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: getStore(format)("notifications.element")})
            //returns saved element to update dataTables
            return apiData;
        })
    ;
}

export function del(tag_ids = [], config = {}) {
    return API.del('v2/tag', tag_ids, config)
        .then(async (response) => {
            if (!response.ok) {
                let toastConfig = {
                    data: "Etiquetas",
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                // api validation errors
                notificate('delete_error', "toast", toastConfig);
                throw await response.json();
            }
            return response.json();
        })
        .then(() => {
            return notificate('delete_ok', "toast", {data: "Etiquetas"});
        })
    ;
}

export function filterTagsByTargetObjectType(tags, associations, target_object_type){
    let filteredTags = [];
    associations = associations.filter(link=> link.target_object_type === target_object_type);

    for(let tag of tags){
        for (let link of associations){
            if(tag.id === link.tag_id && filteredTags.indexOf(tag) == -1){
                filteredTags.push(tag);
            }
        }
    }
    filteredTags = filteredTags.sort((a,b)=>a.name.localeCompare(b.name));
    return filteredTags;
}

export default {
    search,
    find,
    save,
    saveAssociation,
    deleteAssociation,
    del,
    filterTagsByTargetObjectType
}